import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { RouterContext } from "../app/router";

// Public routes (callback, signed-out) render bare; the shell lives in the protected _app layout.
export const Route = createRootRouteWithContext<RouterContext>()({ component: Outlet });
